import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

const dateFormat = (input: string | number | Date): string => {
	const dateObj = new Date(input)

	const year = dateObj.getFullYear()
	const month = String(dateObj.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
	const day = String(dateObj.getDate()).padStart(2, '0')
	const hours = String(dateObj.getHours()).padStart(2, '0')
	const minutes = String(dateObj.getMinutes()).padStart(2, '0')
	const seconds = String(dateObj.getSeconds()).padStart(2, '0')

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

export const formatCommentDate = (date: string | Date): string => {
	const now = dayjs()
	const commentDate = dayjs(date)
	const diffInMinutes = now.diff(commentDate, 'minute')
	const diffInHours = now.diff(commentDate, 'hour')
	const diffInDays = now.diff(commentDate, 'day')

	if (diffInMinutes < 1) {
		return 'just now'
	} else if (diffInMinutes < 60) {
		return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`
	} else if (diffInHours < 24) {
		return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`
	} else if (diffInDays < 7) {
		return `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`
	} else {
		return commentDate.format('MMM D, YYYY [at] h:mm A')
	}
}

export default dateFormat
